import React from 'react'
import Questions from './index'
import { sortResponseKeys } from '../FormHelpers'

interface IProps {
  names: string[]
  responses: any
  corrections?: any
}

const QuestionList = (props: IProps) => {
  const { names, responses, corrections } = props

  return (
    <>
      {sortResponseKeys(responses).map(key => {
        const newNameKeys = [...names]
        newNameKeys.push(key)

        return (
          <Questions
            key={`${newNameKeys.join('-')}-questions`}
            names={newNameKeys}
            responses={responses[key]}
            corrections={corrections && corrections[key]}
          />
        )
      })}
    </>
  )
}

export default QuestionList
